import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Inject } from '@angular/core';
import { LoadingController } from 'ionic-angular';
import { ToastController, App, NavController } from 'ionic-angular';
import { TimesheetlistPage } from '../../pages/timesheetlist/timesheetlist';
import { DOCUMENT } from '@angular/common';
// import { ExpensesPage } from '../../pages/expenses/expenses';


/*
  Generated class for the GlobalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GlobalProvider {

  public ColourBanner1: string;
  public ColourBanner2: string;
  public ColourDeSelected: string;
  public ColourFont: string;
  public ColourFont1: string;
  public ColourFont2: string;
  public ColourHighlight: string;
  public agencyid: string;
  public contactid: string;
  public contacttype: string;
  public fullname: string;
  public timesheettype: string;
  public timesheetid: string;
  public logo: string;
  public login: boolean = false;
  public status: string = "0";
  public period: string = "0";
  public AllowApproval: string;


  public defaultstatus: string = "0";
  public defaultperiod: string = "0";

  public dt2: Array<string>;
  public id: string;

  public type: string;
  public overtime: string;
  public CTRLInterval: string;
  public CTRLMin: string;
  public CTRLMax: string;

  public ndays: number;
  public ndaysIndex: number = 1;
  public nrowsGrid1: number;
  public nrowsGrid2: number;

  //public overtimeArray: Array<string> = ['00:00','00:00','00:00','00:00','00:00','00:00','00:00',];
  public dayArray: Array<string> = ['Zero Days', 'Zero Days', 'Zero Days', 'Zero Days', 'Zero Days', 'Zero Days', 'Zero Days'];
  public TAB2Caption: Array<string>;
  public TAB2id: Array<string>;
  public TAB2TotalTime: Array<string>;
  public grid2Type: string;
  //public overtimeType: string;
  //public quantityOvertime: string;
  public quantityDays: string;

  public loading;
  public tab2id: string;
  public tab2index: number;

  public grid1Visibility: boolean = true;
  public grid2Visibility: boolean = true;
  public expensesVisibility: boolean = true;

  public skiptab2: boolean = false;

  public dt_grid1: any;
  public dt_grid2: any;
  public dt_grid3: any;
  public dt1_grid2: any;


  public dt1table1: any;
  public dt2table1: any;

  public dt_expenses: any;
  public dt_expenses_ddl: any;

  public dt_expenses_total: any;
  public dt_expenses_total_confirm: any;

  public mileage_rate: number = 0;
  public miles: number = 0;
  public miles_amount: number = 0;
  public total_expenses: number = 0;
  public grand_total: number = 0;


  public autofillEnabled: boolean = false;
  public grid1ValueReadOnly: boolean = false;
  public grid2ValueReadOnly: boolean = false;
  public grid3ValueReadOnly: boolean = false;

  public FlipGrids: boolean = false;

  public timesheetinstructions0: string;
  public timesheetinstructions1: string;

  public timesheetinstructions0mobile: string;
  public timesheetinstructions1mobile: string;

  public footersettings: any;

  public TimesheetPeriod: number;

  public TimeInputControl: string;
  // public ratingvalue: string;
  // public timesheetIndex: number;
  // public rate: Array<string> = [];
  session: any;

  public shownGroup = null;
  public showRejectButton: boolean = false;

  public button1caption: string = "";

  public button2caption: string = "";
  public button2validator: string = "";

  public grid2options = [];
  //note : width and height are not necessary now, they are left for history
  public agency_arr: any = [
    { agencyName: "timesheets.axcis.co.uk", agencyID: '9', btnColor: '#D21241', title: 'Axcis Timesheets', width: "197", height: "78" },
    { agencyName: "timesheets.osbornerichardson.com.au", agencyID: '6', btnColor: 'rgb(162, 60, 150)', title: 'ORA Timesheets', width: "166", height: "58" },
    { agencyName: "timesheets.osbornerichardson.com", agencyID: '1', btnColor: 'rgb(162, 60, 150)', title: 'OR Timesheets', width: "158", height: "58" },
    { agencyName: "consultingpoint", agencyID: '7', btnColor: '#595959', title: 'Consulting Point Timesheets', width: "197", height: "76" },
    { agencyName: "actamarine", agencyID: '10', btnColor: '#008e8e', title: 'Actamarine Timesheets', width: "197", height: "32" },
    { agencyName: "langhambull", agencyID: '11', btnColor: '#206fb1', title: 'Langham Bull Timesheets', width: "197", height: "31" },
    { agencyName: "contracts.mustardjobs.co.uk", agencyID: '12', btnColor: '#73cc00', title: 'Mustard Timesheets', width: "197", height: "44" },
    { agencyName: "franklinfitch", agencyID: '13', btnColor: '#004750', title: 'Franklin Fitch Timesheets', width: "197", height: "34" },
    { agencyName: "talentpoint", agencyID: '14', btnColor: '', title: 'Talent Point Timesheets', width: "100", height: "100" },
    { agencyName: "scarletfraser", agencyID: '15', btnColor: '#E3003A', title: 'Scarlet Fraser Timesheets', width: "300", height: "22" },
    { agencyName: "ameo", agencyID: '16', btnColor: '#ea252e', title: 'Ameo Timesheets', width: "197", height: "38" },
    { agencyName: "vq", agencyID: '17', btnColor: '#ff893e', title: 'VQ Timesheets', width: "197", height: "49" },
    { agencyName: "my", agencyID: '2', btnColor: '#5ba9a4', title: 'TheTimeGenie Timesheets', width: "197", height: "39" },
    { agencyName: "agora", agencyID: '80', btnColor: '#62ae45', title: 'The Agora Clinic Timesheets', width: "197", height: "108" },
    { agencyName: "whitehall", agencyID: '81', btnColor: '#950026', title: 'White Hall Resources Timesheets', width: "197", height: "45" },
    { agencyName: "evansdenham", agencyID: '90', btnColor: '#595a5c', title: 'Evans Denham Timesheets', width: "197", height: "71" },
    { agencyName: "hamilton-barnes", agencyID: '95', btnColor: '#7ac043', title: 'Hamilton Barnes Timesheets', width: "199", height: "38" },
    { agencyName: "innovasearch", agencyID: '99', btnColor: '#2ba9cf', title: 'Specialist Search & Selection Timesheets', width: "183", height: "90" },
    { agencyName: "macdonald", agencyID: '107', btnColor: '#114f98', title: 'Macdonald Mcewan Timesheets', width: "197", height: "52" },
    { agencyName: "connectedconsulting", agencyID: '110', btnColor: '#015697', title: 'Connected Consulting Timesheets', width: "197", height: "139" },
    { agencyName: "vlarecruitment", agencyID: '113', btnColor: '#d4a53f', title: 'Victoria Linfield Associates Timesheets', width: "197", height: "197" },
    { agencyName: "bauhaus", agencyID: '114', btnColor: '#2b2761', title: 'Bauhaus Recruitment Timesheets', width: "197", height: "197" },
    { agencyName: "aspion", agencyID: '115', btnColor: '#e55825', title: 'Aspion Recruitment Timesheets', width: "197", height: "197" },
    { agencyName: "hrprecruitmentltd", agencyID: '116', btnColor: '#f7941d', title: 'HRP Recruitment Timesheets', width: "197", height: "197" },
    { agencyName: "lunariapartners", agencyID: '117', btnColor: '#2E8F54', title: 'Lunaria Partners LTD Timesheets', width: "197", height: "197" },
    { agencyName: "paripassu", agencyID: '123', btnColor: '#92c11a', title: 'Pari Passu Group Limited Timesheets', width: "197", height: "197" },
    { agencyName: "redfish", agencyID: '124', btnColor: '#CE3235', title: 'Redfish Midlands Timesheets', width: "197", height: "197" },
    { agencyName: "empathytalent", agencyID: '125', btnColor: '#1c1c1c', title: 'Empathy Talent Timesheets', width: "197", height: "197" },
    { agencyName: "fiveeducation", agencyID: '127', btnColor: '#0e93d1', title: 'Five Education Timesheets', width: "197", height: "197" },
    { agencyName: "ekim", agencyID: '129', btnColor: '#545454', title: 'EKIM Consulting Timesheets', width: "197", height: "197" },
    { agencyName: "theindustryclub", agencyID: '140', btnColor: '#000000', title: 'The Industry Club Timesheets', width: "197", height: "197" },
    { agencyName: "send-help", agencyID: '141', btnColor: '#1055b2', title: 'SENDhelp Timesheets', width: "197", height: "197" },
    { agencyName: "ellismack", agencyID: '143', btnColor: '#23aa65', title: 'Ellis Mack Timesheets', width: "197", height: "197" },
    { agencyName: "pinnacle-learning", agencyID: '144', btnColor: '#c81e7b', title: 'Pinnacle Learning Timesheets', width: "197", height: "197" },
    { agencyName: "middletonjones", agencyID: '145', btnColor: '#0949b8', title: 'Middleton Jones Timesheets', width: "197", height: "197" },
    { agencyName: "keylime", agencyID: '148', btnColor: '#9acd32', title: 'Keylime Consultants Timesheets', width: "197", height: "197" },
    { agencyName: "maclean", agencyID: '147', btnColor: '#192c61', title: 'Goldsails Ltd Timesheets', width: "197", height: "197" },
    { agencyName: "goldsails", agencyID: '149', btnColor: '#e0a125', title: 'Maclean Timesheets', width: "197", height: "197" },
    { agencyName: "chieducation", agencyID: '155', btnColor: '#1E7ABD', title: 'Chi Education Timesheets', width: "197", height: "197" },
    { agencyName: "staffingsolutions", agencyID: '189', btnColor: '#13592E', title: 'Financial Staffing Solutions Timesheets', width: "197", height: "197" },
    { agencyName: "apache", agencyID: '190', btnColor: '#2d5281', title: 'Apache Associates Timesheets', width: "197", height: "197" },
    { agencyName: "saaf", agencyID: '268', btnColor: '#8662a8', title: 'SAAF Supply LTD Timesheets', width: "197", height: "197" },

  ]

  // public agency_arr: any = [
  //   { agencyName: "axcis.ts-entry.com", agencyID: '9', btnColor: '#D21241', title: 'Axcis Timesheets', width: "197", height: "78" },
  //   { agencyName: "orpty.ts-entry.com", agencyID: '6', btnColor: 'rgb(162, 60, 150)', title: 'ORA Timesheets', width: "166", height: "58" },
  //   { agencyName: "or.ts-entry.com", agencyID: '1', btnColor: 'rgb(162, 60, 150)', title: 'OR Timesheets', width: "158", height: "58" },
  //   { agencyName: "consultingpoint", agencyID: '7', btnColor: '#595959', title: 'Consulting Point Timesheets', width: "197", height: "76" },
  //   { agencyName: "actamarine", agencyID: '10', btnColor: '#008e8e', title: 'Actamarine Timesheets', width: "197", height: "32" },
  //   { agencyName: "langhambull", agencyID: '11', btnColor: '#206fb1', title: 'Langham Bull Timesheets', width: "197", height: "31" },
  //   { agencyName: "contracts.mustardjobs.co.uk", agencyID: '12', btnColor: '#73cc00', title: 'Mustard Timesheets', width: "197", height: "44" },
  //   { agencyName: "franklinfitch", agencyID: '13', btnColor: '#004750', title: 'Franklin Fitch Timesheets', width: "197", height: "34" },
  //   { agencyName: "talentpoint", agencyID: '14', btnColor: '', title: 'Talent Point Timesheets', width: "100", height: "100" },
  //   { agencyName: "scarletfraser", agencyID: '15', btnColor: '#E3003A', title: 'Scarlet Fraser Timesheets', width: "300", height: "22" },
  //   { agencyName: "ameo", agencyID: '16', btnColor: '#ea252e', title: 'Ameo Timesheets', width: "197", height: "38" },
  //   { agencyName: "vq.ts-entry.com", agencyID: '17', btnColor: '#ff893e', title: 'VQ Timesheets', width: "197", height: "49" },
  //   { agencyName: "my", agencyID: '2', btnColor: '#5ba9a4', title: 'TheTimeGenie Timesheets', width: "197", height: "39" },
  //   { agencyName: "agora", agencyID: '80', btnColor: '#62ae45', title: 'The Agora Clinic Timesheets', width: "197", height: "108" },
  //   { agencyName: "whitehall", agencyID: '81', btnColor: '#950026', title: 'White Hall Resources Timesheets', width: "197", height: "45" },
  //   { agencyName: "evansdenham", agencyID: '90', btnColor: '#595a5c', title: 'Evans Denham Timesheets', width: "197", height: "71" },
  //   { agencyName: "hamilton-barnes", agencyID: '95', btnColor: '#7ac043', title: 'Hamilton Barnes Timesheets', width: "199", height: "38" },
  //   { agencyName: "innovasearch", agencyID: '99', btnColor: '#2ba9cf', title: 'Specialist Search & Selection Timesheets', width: "183", height: "90" },
  //   { agencyName: "macdonald", agencyID: '107', btnColor: '#114f98', title: 'Macdonald Mcewan Timesheets', width: "197", height: "52" },
  //   { agencyName: "cc.ts-entry.com", agencyID: '110', btnColor: '#015697', title: 'Connected Consulting Timesheets', width: "197", height: "139" },
  //   { agencyName: "vla.ts-entry.com", agencyID: '113', btnColor: '#d4a53f', title: 'Victoria Linfield Associates Timesheets', width: "197", height: "197" },
  //   { agencyName: "bauhaus.ts-entry.com", agencyID: '114', btnColor: '#2b2761', title: 'Bauhaus Recruitment Timesheets', width: "197", height: "197" },
  //   { agencyName: "aspion", agencyID: '115', btnColor: '#e55825', title: 'Aspion Recruitment Timesheets', width: "197", height: "197" },
  //   { agencyName: "hrprecruitmentltd", agencyID: '116', btnColor: '#f7941d', title: 'HRP Recruitment Timesheets', width: "197", height: "197" },
  //   { agencyName: "lunariapartners", agencyID: '117', btnColor: '#2E8F54', title: 'Lunaria Partners LTD Timesheets', width: "197", height: "197" },
  //   { agencyName: "paripassu", agencyID: '123', btnColor: '#92c11a', title: 'Pari Passu Group Limited Timesheets', width: "197", height: "197" },
  //   { agencyName: "redfish", agencyID: '124', btnColor: '#CE3235', title: 'Redfish Midlands Timesheets', width: "197", height: "197" },
  //   { agencyName: "empathytalent", agencyID: '125', btnColor: '#1c1c1c', title: 'Empathy Talent Timesheets', width: "197", height: "197" },
  //   { agencyName: "five.ts-entry.com", agencyID: '127', btnColor: '#0e93d1', title: 'Five Education Timesheets', width: "197", height: "197" },
  //   { agencyName: "ekim.ts-entry.com", agencyID: '129', btnColor: '#545454', title: 'EKIM Consulting Timesheets', width: "197", height: "197" },
  //   { agencyName: "tic.ts-entry.com", agencyID: '140', btnColor: '#000000', title: 'The Industry Club Timesheets', width: "197", height: "197" },
  //   { agencyName: "send-help", agencyID: '141', btnColor: '#1055b2', title: 'SENDhelp Timesheets', width: "197", height: "197" },
  //   { agencyName: "ellismack", agencyID: '143', btnColor: '#23aa65', title: 'Ellis Mack Timesheets', width: "197", height: "197" },
  //   { agencyName: "pinnacle-learning", agencyID: '144', btnColor: '#c81e7b ', title: 'Pinnacle Learning Timesheets', width: "197", height: "197" },
  // ]
  
  constructor(public http: HttpClient, public loadingCtrl: LoadingController,
    private toastCtrl: ToastController, public appCtrl: App, @Inject(DOCUMENT) private document: Document) {

  }

  getPortalID() {
    // debugger;
    var url = window.location.host;
    //var url = "m.timesheets.osbornerichardson.com.au";
    //var url = "m.timesheets.osbornerichardson.com";
    //var url = "m.my.ttgdemo.com";
    //var url = 'm.timesheets.axcis.co.uk';
    //var url = 'm.timesheets.talentpoint.co';
    //var url = 'm.langhambull.ttgdemo.com';
    //var url = 'm.bauhaus.ttgdemo.com';
    var portal = "";

    url = url.replace("http://", "");
    url = url.replace("https://", "");

    if (url.includes('m.')) {
      //temporary until we make a global dictionary
      portal = url.replace("m.", "").split("/")[0];
    }
    else {

      url = url.split('.')[0];
      portal = url.replace('mobile', '');

      if (portal == 'mdemo') {
        portal = 'http://www.ttg2.chisites.net';
      }
    }

    return portal;
  }

  public createLoader() {
    this.loading = this.loadingCtrl.create({ content: '<ion-spinner></ion-spinner><p>Loading</p>' });
  }

  goToTimesheet(landingpage: string) {

    let activeNav: NavController = this.appCtrl.getActiveNav();
    this.session = window.localStorage.getItem('session');
    if (!this.session) {
      if (landingpage == 'Timesheets' || landingpage == 'Timesheets3' || landingpage == 'timesheettype3') {

        activeNav.setRoot(TimesheetlistPage);
      }

      return false;
    }
    return this.session;

  }

  presentToast(msg, timems=3000) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: timems,
      position: 'bottom',
      showCloseButton: true, 
      closeButtonText: 'Dismiss',
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }

  setGrid2Option() {
    //get grid2 ddl options 
    //console.log('hello2', this.dt2table1);
    this.grid2options = [];
    var ddldaysarray = this.dt2table1[0]['DayDDLValues'].split(",");
    for (var i = 0; i < ddldaysarray.length; i++) {
      var val = "0.00";
      if (ddldaysarray[i].trim() == 'Zero Days' || ddldaysarray[i].trim() == 'Zero')
        val = "0.00";
      else if (ddldaysarray[i].trim() == 'Half Day')
        val = "0.50";
      else if (ddldaysarray[i].trim() == 'One Day' || ddldaysarray[i].trim() == 'One')
        val = "1.00";
      else
        val = ddldaysarray[i].split(" ")[0];

      this.grid2options.push({ text: ddldaysarray[i].trim(), value: val });
    }

    // change value of quantity field to 2 fixed decimals String
    for (var i = 0; i < this.dt2table1.length; i++) {
      this.dt2table1[i].Quantity = Number(this.dt2table1[i].Quantity).toFixed(2).toString();


      //if this value is not in the options list, add it as an option
      let res = this.grid2options.find(element => element.value == this.dt2table1[i].Quantity);
      if (!res) this.grid2options.push({ text: this.dt2table1[i].Quantity, value: this.dt2table1[i].Quantity });
    }
  }

  // logout(){
    
  //   this.autofillEnabled = false;
  //   localStorage.clear();
  //   //this.navCtrl.push(LoginPage);

  //   let activeNav: NavController = this.appCtrl.getActiveNav();
  //   activeNav.setRoot(LoginPage);

  //   try {
  //     this.loading.dismiss();
  //   } catch(ex) {}

  // }

}



// WEBPACK FOOTER //
// ./src/providers/global/global.ts